import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGuidanceDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(2 2)",
		d: "M33.7501 35.9965C34.9969 35.9965 36 34.9934 36 33.7466V11.2473C36 10.0005 34.9969 8.99736 33.7501 8.99736C32.5032 8.99736 31.5001 10.0005 31.5001 11.2473V28.3186L3.8448 0.653885C2.96358 -0.217962 1.53863 -0.217962 0.657405 0.653885C-0.223816 1.52573 -0.214441 2.96006 0.657405 3.84128L28.3128 31.4966H11.2414C9.9946 31.4966 8.99151 32.4997 8.99151 33.7466C8.99151 34.9934 9.9946 35.9965 11.2414 35.9965H33.7407H33.7501Z"
	})
});
export default SvgGuidanceDown;
